export default "__VITE_ASSET__zkLgUPI4__"